<template>
  <div v-if="isVisible" class="custom-modal-overlay">
    <div class="custom-modal-container">
      <div v-if="currentPage === 0">
        <div class="custom-modal-header">
          <h3 style="font-size: 24px; font-weight: 700">
            Business Information
          </h3>
        </div>

        <div class="custom-modal-body">
          <div class="row" style="margin-bottom: 20px">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Account Type"
                placeholder="accountType"
                value="Business Account"
                disabled
              ></fg-input>
            </div>
            <div class="col-md-4">
              <label>Business Category</label>
              <select
                class="form-control op-border"
                id="businessCategory"
                v-model="agent.businessCategory"
              >
                <option value="">Select Business Category</option>
                <option
                  v-for="role in businessCategories"
                  :key="role.key"
                  :value="role.key"
                >
                  {{ role.label }}
                </option>
              </select>
            </div>
            <div class="col-md-4">
              <label>Business Industry</label>
              <select
                class="form-control op-border"
                id="businessIndustry"
                v-model="agent.businessIndustry"
              >
                <option value="">Select Business Industry</option>
                <option v-for="role in businessIndustries" :key="role.key">
                  {{ role.label }}
                </option>
              </select>
            </div>
          </div>

          <div class="row" style="margin-bottom: 20px">
            <div class="col-md-4">
              <label>Company Type</label>
              <select
                class="form-control op-border"
                id="companyType"
                v-model="agent.businessType"
              >
                <option value="">Select Company Type</option>
                <option
                  value=""
                  :style="{
                    display: !agent.businessCategory ? 'block' : 'none',
                  }"
                >
                  Choose a Business Category
                </option>
                <option
                  value="Business Name (BN)"
                  :style="{
                    display:
                      agent.businessCategory === 'sole-proprietor'
                        ? 'block'
                        : 'none',
                  }"
                >
                  Business Name (BN)
                </option>
                <option
                  value="Registered Company (RC)"
                  :style="{
                    display:
                      agent.businessCategory ===
                      'private-limited-liability-company'
                        ? 'block'
                        : 'none',
                  }"
                >
                  Registered Company (RC)
                </option>
              </select>
            </div>
            <div
              class="col-md-4"
              v-if="agent.businessCategory === 'sole-proprietor'"
            >
              <label>Partnership Business</label>
              <select
                class="form-control op-border"
                id="selectPartnership"
                v-model="selectedPartnershipType"
              >
                <option value="">Select Partnership Business</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
          </div>

          <div class="row" style="align-items: center; margin: 30px 0">
            <div class="col-md-4">
              <fg-input
                type="number"
                label="RC Number"
                v-model="agent.rcNumberInput"
                placeholder="RC Number"
              ></fg-input>
            </div>
            <div class="col-md-4">
              <button
                class="btn btn-info m-2"
                style="
                  padding: 8px 48px;
                  display: flex;
                  align-items: center;
                  gap: 4px;
                  justify-content: center;
                "
                @click="validateTin"
                :disabled="loading || !agent.rcNumberInput"
              >
                <span v-if="loading" class="spin"></span>
                VALIDATE RC Number
              </button>
            </div>
          </div>

          <div class="row" style="margin-bottom: 20px">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Business Name"
                placeholder="Business Name"
                v-model="rcData.companyName"
              >
              </fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Email Address"
                placeholder="Email Address"
                v-model="rcData.emailAddress"
              >
              </fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Phone Number"
                placeholder="Phone Number"
                v-model="rcData.phoneNumber"
                maxlength="11"
                @input="
                  rcData.phoneNumber = rcData.phoneNumber.replace(/\D/g, '')
                "
              />
            </div>
          </div>

          <div class="row" style="margin-bottom: 20px">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="RC Number"
                placeholder="RC Number"
                v-model="rcData.rcNumber"
              >
              </fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="date"
                label="Date of Incorporation"
                placeholder="Date of Incorporation"
                v-model="formattedDate"
              >
              </fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Business Address"
                placeholder="Business Address"
                v-model="rcData.companyAddress"
              >
              </fg-input>
            </div>
          </div>

          <div class="row" style="margin-bottom: 20px">
            <div class="col-md-4" v-if="rcData.state">
              <fg-input
                type="text"
                label="State"
                placeholder="State"
                v-model="rcData.state"
              >
              </fg-input>
            </div>

            <div class="col-md-4" v-else>
              <label>State</label>
              <select
                class="form-control op-border"
                id="rate-type"
                required
                v-model="rcData.state"
                @change="fetchLgas()"
              >
                <option value="">State</option>
                <option v-for="st in utils.allStates" :key="st" :value="st">
                  {{ st }}
                </option>
              </select>
            </div>

            <div class="col-md-4" v-if="rcData.lga">
              <fg-input
                type="text"
                label="L.G.A"
                placeholder="L.G.A"
                v-model="rcData.lga"
              >
              </fg-input>
            </div>

            <div class="col-md-4" v-else>
              <label for="localGovernment">L.G.A of Origin</label>
              <select
                id="localGovernment"
                class="form-control"
                required
                v-model="rcData.lga"
              >
                <option value="" disabled>Select Local Government</option>
                <option
                  v-for="lga in utils.lgas"
                  :key="lga.id"
                  :value="lga.name"
                >
                  {{ lga.name }}
                </option>
              </select>
              <span v-if="utils.lgaLoading">Fetching LGAs...</span>
            </div>
          </div>

          <h4>Sources of Income</h4>
          <div style="margin-bottom: 40px">
            <div class="row" style="margin-bottom: 20px">
              <div class="col-md-4">
                <label>What is your business' annual income</label>
                <select
                  class="form-control op-border"
                  id="annualIncome"
                  v-model="agent.sourcesOfIncome[0].annualIncome"
                >
                  <option value="">Select Annual Income</option>
                  <option
                    v-for="price in annualIncome"
                    :key="price.key"
                    :value="price.key"
                  >
                    {{ price.label }}
                  </option>
                </select>
              </div>

              <div class="col-md-4">
                <label>Other sources of income?</label>
                <select
                  class="form-control op-border"
                  id="selectedOtherIncome"
                  v-model="selectedOtherIncome"
                >
                  <option value="">Select Other sources of income</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              <div class="col-md-4" v-if="selectedOtherIncome === 'Yes'">
                <label>Industry</label>
                <select
                  class="form-control op-border"
                  id="industry"
                  v-model="agent.sourcesOfIncome[1].industry"
                >
                  <option value="">Select Industry</option>
                  <option v-for="role in businessIndustries" :key="role.key">
                    {{ role.label }}
                  </option>
                </select>
              </div>
            </div>

            <div class="row" v-if="selectedOtherIncome === 'Yes'">
              <div class="col-md-4">
                <label>What is your annual income (Other Source)</label>
                <select
                  class="form-control op-border"
                  id="annualIncome"
                  v-model="agent.sourcesOfIncome[1].annualIncome"
                >
                  <option value="">Select Annual Income</option>
                  <option
                    v-for="price in annualIncome"
                    :key="price.key"
                    :value="price.key"
                  >
                    {{ price.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="text-center" style="display: flex; align-items: center">
            <button
              class="btn btn-info m-2"
              @click="closeModal"
              style="
                padding: 8px 48px;
                display: flex;
                align-items: center;
                gap: 4px;
                justify-content: center;
              "
            >
              BACK
            </button>

            <button
              class="btn btn-info m-2"
              style="
                padding: 8px 48px;
                display: flex;
                align-items: center;
                gap: 4px;
                justify-content: center;
              "
              @click="addBusinessInfo"
            >
              <span v-if="loading" class="spin"></span>
              CONTINUE
            </button>
          </div>
        </div>
      </div>

      <div v-if="currentPage === 1">
        <h3 style="font-size: 20px; font-weight: 700">KYC Documents</h3>
        <div class="row d-flex flex-wrap" style="row-gap: 15px">
          <div
            v-for="document in filteredDocuments"
            :key="document.key"
            class="col-md-4 d-flex flex-column"
            style="justify-content: end; min-height: 100px"
          >
            <label for="inlineFormInput">{{ document.name }}</label>

            <input
              :id="'fileInput_' + document.key"
              type="file"
              class="form-control d-none"
              @change="(e) => handleFileUpload(e, document.key)"
            />

            <label :for="'fileInput_' + document.key" class="file-label"
              >Choose File</label
            >
          </div>
        </div>

        <div
          v-if="uploadedDocuments.length > 0"
          class="kyc-uploaded"
          style="margin-bottom: 40px"
        >
          <h4>Uploaded Documents</h4>

          <div
            class="row d-flex flex-wrap"
            style="align-content: baseline; row-gap: 40px"
          >
            <div
              class="col-md-3"
              :key="document.key"
              v-for="document in uploadedDocuments"
            >
              <p>{{ document.name }}</p>

              <div
                v-if="
                  ['image/png', 'image/jpg', 'image/jpeg'].includes(
                    document.type,
                  )
                "
                style="
                  width: 100px;
                  height: 80px;
                  background-size: cover;
                  background-position: center;
                  background-repeat: no-repeat;
                  border-radius: 4px;
                "
                :style="{
                  backgroundImage: `url('${document.preview}')`,
                }"
              ></div>
              <img
                v-else
                src="../../assets/img/pdf.png"
                alt="PDF Icon"
                style="width: 100px; height: 80px"
              />
            </div>
          </div>
        </div>

        <button
          class="btn btn-info m-2"
          style="
            padding: 8px 48px;
            display: flex;
            align-items: center;
            gap: 4px;
            justify-content: center;
          "
          @click="uploadKycDocuments"
        >
          <span v-if="loading" class="spin"></span>

          SUBMIT
        </button>
      </div>

      <div v-if="currentPage === 2">
        <h3 style="font-size: 20px; font-weight: 700">Director Information</h3>
        <AgentInformation
          agentType="Directors"
          :agentList="directorsList"
          :fields="agentInformation"
          :handleBvnValidation="handleBvnValidation"
          :isValidating="loading"
          :isValidatingNin="isValidatingNin"
          :addNewAgent="addNewAgent"
          :validateDateOfBirth="validateDateOfBirth"
          :handleBvnInput="handleBvnInput"
          :getOptions="getOptions"
          :handleSelectChange="handleSelectChange"
          :handleInput="handleInput"
        />

        <div class="text-center" style="display: flex; align-items: center">
          <button
            class="btn btn-info m-2"
            style="
              padding: 8px 48px;
              display: flex;
              align-items: center;
              gap: 4px;
              justify-content: center;
            "
            :disabled="loading || isFormIncomplete"
            @click="addDirectors"
          >
            <span v-if="loading" class="spin"></span>
            CONTINUE
          </button>
        </div>
      </div>

      <div v-if="currentPage === 3">
        <h3 style="font-size: 20px; font-weight: 700">
          Shareholders Information
        </h3>
        <AgentInformation
          agentType="Shareholders"
          :agentList="shareholdersList"
          :fields="agentInformation"
          :handleBvnValidation="handleBvnValidation"
          :isValidating="loading"
          :isValidatingNin="isValidatingNin"
          :addNewAgent="addNewAgent"
          :validateDateOfBirth="validateDateOfBirth"
          :handleBvnInput="handleBvnInput"
          :getOptions="getOptions"
          :handleSelectChange="handleSelectChange"
          :handleInput="handleInput"
        />

        <div class="text-center" style="display: flex; align-items: center">
          <button
            class="btn btn-info m-2"
            style="
              padding: 8px 48px;
              display: flex;
              align-items: center;
              gap: 4px;
              justify-content: center;
            "
            :disabled="loading || isShareholderFormIncomplete"
            @click="addShareholders"
          >
            <span v-if="loading" class="spin"></span>
            CONTINUE
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../store/axios";
import Swal from "sweetalert2";
import moment from "moment";
import { mapState, mapActions } from "vuex";
import AgentInformation from "../../components/AgentInformation.vue";
import {
  businessCategories,
  businessIndustries,
  occupation,
  annualIncome,
  requiredDocuments,
  kycCategories,
  companyTypes,
  agentInformation,
} from "../../constants/agents-information";
import { handleDateOfBirthInput, validateBvnInput } from "../../utils/utils";

export default {
  components: {
    AgentInformation,
  },

  props: {
    isVisible: Boolean,
    agentId: {
      type: String,
      required: true,
    },
    agentFirstName: {
      type: String,
      required: true,
    },
    agentMiddleName: {
      type: String,
      required: true,
    },
    agentLastName: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      isValidatingNin: false,
      currentPage: 0,
      businessCategories: businessCategories,
      businessIndustries: businessIndustries,
      occupations: occupation,
      annualIncome: annualIncome,
      cacNumber: "",
      agent: {
        bvn: "",
        dateOfBirth: "",
        rcNumberInput: "",
        businessCategory: "",
        businessIndustry: "",
        businessType: "",
        sourcesOfIncome: [{ annualIncome: "", industry: "" }],
      },
      rcData: {
        city: "",
        companyAddress: "",
        companyName: "",
        emailAddress: "",
        lga: "",
        rcNumber: "",
        registrationDate: "",
        state: "",
        companyType: "",
        phoneNumber: "",
      },
      documentsToUpload: [],
      allDocumentsUploaded: false,
      files: {
        requiredDocuments,
        uploadedDocuments: [],
      },
      requiredDocuments: requiredDocuments,
      kycCategories,
      companyTypes,
      selectedPartnershipType: "",
      selectedPartnership: null,
      directorsList: [{ ...this.getEmptyForm() }],
      shareholdersList: [{ ...this.getEmptyForm() }],
      agentInformation,
    };
  },

  computed: {
    ...mapState(["auth", "utils"]),

    formattedDate: {
      get() {
        return moment(this.rcData.registrationDate).format("YYYY-MM-DD");
      },
      set(value) {
        this.rcData.registrationDate = moment(value).format("YYYY-MM-DD");
      },
    },

    selectedOtherIncome: {
      get() {
        return this.agent.sourcesOfIncome.length > 1 ? "Yes" : "No";
      },
      set(value) {
        if (value === "Yes" && this.agent.sourcesOfIncome.length === 1) {
          this.agent.sourcesOfIncome.push({ industry: "", annualIncome: "" });
        } else if (value === "No" && this.agent.sourcesOfIncome.length > 1) {
          this.agent.sourcesOfIncome.splice(1);
        }
      },
    },

    filteredDocuments() {
      const filtered = this.documentsToUpload
        .map((key) => this.requiredDocuments.find((doc) => doc.key === key))
        .filter(Boolean);
      return filtered;
    },

    uploadedDocuments() {
      return this.filteredDocuments.filter((doc) => doc.file);
    },

    isFormIncomplete() {
      return this.directorsList.some((agent) =>
        Object.values(agent).some((value) => value === ""),
      );
    },
    isShareholderFormIncomplete() {
      return this.shareholdersList.some((agent) =>
        Object.values(agent).some((value) => value === ""),
      );
    },
  },

  methods: {
    closeModal() {
      this.$emit("close");
    },

    ...mapActions(["getStates", "getLgas"]),

    fetchLgas() {
      this.getLgas(this.rcData.state);
    },

    isValidPhoneNumber(phoneNumber) {
      if (!phoneNumber) return false;
      return phoneNumber.length === 11 && /^[0-9]+$/.test(phoneNumber);
    },

    async validateTin() {
      try {
        if (!this.agent.rcNumberInput || !this.agent.businessType) {
          this.$toast.error("Please enter RCNumber and Company Type");
          return;
        }

        this.loading = true;

        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/kyc/cac-lookup/${this.agentId}`,
          {
            rcNumber: this.agent.rcNumberInput,
            businessType: this.agent.businessType,
          },
        );

        this.rcData = response.data.data;
        console.log(this.rcData);

        const formattedState =
          this.rcData.state.charAt(0).toUpperCase() +
          this.rcData.state.slice(1).toLowerCase();

        this.rcData.state = formattedState.toLowerCase().includes("state")
          ? formattedState
          : `${formattedState} State`;

        if (response.data.status === "success") {
          this.$toast.success(response.data.message);
          this.loading = false;
        }

        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.$toast.error(err.res.data.message);
      }
    },

    handleFileUpload(event, documentKey) {
      const file = event.target.files[0];
      if (file) {
        const document = this.filteredDocuments.find(
          (doc) => doc.key === documentKey,
        );
        if (document) {
          document.file = file;

          document.type = file.type;
          this.checkAllDocumentsUploaded();

          const reader = new FileReader();
          reader.onloadend = function () {
            document.preview = reader.result;
          };
          reader.readAsDataURL(file);
        }
      }
    },

    checkAllDocumentsUploaded() {
      this.allDocumentsUploaded = this.filteredDocuments.every(
        (doc) => doc.file !== null,
      );
    },

    validateDateOfBirth(value, agent, validation) {
      const { formattedValue, validationError } = handleDateOfBirthInput(value);

      agent.dateOfBirth = formattedValue;
      validation.dateOfBirth = validationError;
    },

    validatePayload(payload) {
      let missingFields = [];

      if (!payload.businessAddress) {
        missingFields.push("Business Address");
      }
      if (!payload.businessCategory) {
        missingFields.push("Business Category");
      }
      if (!payload.businessIndustry) {
        missingFields.push("Business Industry");
      }
      if (
        payload.businessCategory === "sole-proprietor" &&
        payload.isPartnershipBusiness === null
      ) {
        missingFields.push("Select Partnership Business");
      }
      if (!payload.businessLGA) {
        missingFields.push("Business LGA");
      }
      if (!payload.businessName) {
        missingFields.push("Business Name");
      }
      if (!payload.businessState) {
        missingFields.push("Business State");
      }
      if (!payload.businessType) {
        missingFields.push("Business Type");
      }
      if (!payload.businessPhoneNumber) {
        missingFields.push("Business Phone Number");
      }
      if (!payload.businessEmail) {
        missingFields.push("Email");
      }
      if (!payload.rcNumber) {
        missingFields.push("RC Number");
      }
      if (!payload.registrationDate) {
        missingFields.push("Registration Date");
      }

      payload.sourcesOfIncome.forEach((source, index) => {
        if (!source.industry && selectedOtherIncome === "Yes") {
          missingFields.push(`Industry${1}`);
        }
        if (!source.annualIncome) {
          missingFields.push(`Annual Income${index + 1}`);
        }
      });

      if (missingFields.length > 0) {
        Swal.fire({
          icon: "error",
          title: "Missing Fields",
          html: `<b>Please fill in the following fields:</b><br> ${missingFields.join(
            "<br>",
          )}`,
          confirmButtonText: "OK",
        });
        return false;
      }

      return true;
    },

    async upgradeAgent() {
      this.loading = true;
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/upgrade-agent-account/${this.agentId}`,
        );

        this.loading = false;
      } catch (err) {
        const { data } = err.response.data;
        this.loading = false;
        this.$toast.error(data.message);
      }
    },

    async addBusinessInfo() {
      const filteredSources =
        this.selectedOtherIncome === "No"
          ? [this.agent.sourcesOfIncome[0]]
          : this.agent.sourcesOfIncome;

      const payload = {
        businessAddress: this.rcData.companyAddress,
        businessCategory: this.agent.businessCategory,
        businessIndustry: this.agent.businessIndustry,
        businessLGA: this.rcData.lga,
        businessName: this.rcData.companyName,
        businessState: this.rcData.state,
        businessType: this.agent.businessType,
        businessEmail: this.rcData.emailAddress,
        isPartnershipBusiness: this.selectedPartnership,
        rcNumber: this.rcData.rcNumber,
        registrationDate: this.rcData.registrationDate,
        businessPhoneNumber: this.rcData.phoneNumber,
        businessLandmark: "",
        sourcesOfIncome: filteredSources.map((source) => ({
          industry: source.industry || "",
          annualIncome: source.annualIncome || "",
        })),
      };

      if (!this.validatePayload(payload)) {
        return;
      }

      await this.upgradeAgent();

      try {
        this.loading = true;

        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/kyc/addBusinessInformation/${this.agentId}`,
          payload,
        );

        if (res.data.status === "success") {
          this.documentsToUpload = res.data.documentsToUpload;

          if (
            this.agent.businessCategory === "private-limited-liability-company"
          ) {
            this.currentPage = 2;
          } else {
            this.currentPage = 1;
          }
        } else if (res.data.status === "failed") {
          Swal.fire({
            title: "Business Information Submission Failed",
            text: `${res.data.message}`,
            icon: "error",
            confirmButtonText: "OK",
            showCancelButton: false,
          });
        }

        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.$toast.error(err.res.data.message);
      }
    },

    async uploadKycDocuments() {
      const formData = new FormData();

      this.filteredDocuments.forEach((doc) => {
        if (doc.file) {
          formData.append(doc.key, doc.file);
        }
      });

      const apiUrl = `${process.env.VUE_APP_API_URL}/kyc/upload-document/${this.agentId}`;

      try {
        this.loading = true;
        const response = await axios({
          method: "post",
          url: apiUrl,
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
        });

        const { status } = response.data;

        if (status === "success") {
          this.isVisible = false;
          Swal.fire({
            icon: "success",
            title: "ACCOUNT UPGRADED",
            html: `<p>You have upgraded <strong>${this.agentFirstName} ${this.agentMiddleName} ${this.agentLastName}</strong> to a <strong>Business Account</strong></p>`,
            confirmButtonText: "Proceed to all agents",
            showCancelButton: false,
          }).then(() => {
            this.$router.push({ name: "All Agents" });
            window.location.reload();
          });
        }
      } catch (error) {
        this.$toast.error(error.response.data.message);
      } finally {
        this.loading = false;
      }
    },

    getEmptyForm() {
      return {
        firstName: "",
        middleName: "",
        lastName: "",
        gender: "",
        stateOfOrigin: "",
        lgaOfOrigin: "",
        residentialAddress: "",
        nin: "",
        dateOfBirth: "",
        bvn: "",
      };
    },

    addNewAgent(list) {
      list.push(this.getEmptyForm());
    },

    async validateBvn(payload) {
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/kyc/validateBvn`,
          payload,
        );

        if (response.data.status === "success") {
          this.$toast.success(response.data.message);
          return response.data;
        }
      } catch (error) {
        this.$toast.error(error.response.data.message);
      }
    },

    async handleBvnValidation(agent, list, index) {
      if (!agent.bvn || !agent.dateOfBirth) {
        alert("Please provide BVN and Date of Birth");
        return;
      }

      try {
        this.loading = true;

        const result = await this.validateBvn({
          bvn: agent.bvn,
          dateOfBirth: agent.dateOfBirth,
        });

        if (result.status === "success") {
          const updatedData = {
            ...result.data,
            bvn: agent.bvn,
            dateOfBirth: agent.dateOfBirth,
            address: result.data.residentialAddress,
            lga: result.data.lgaOfOrigin,
            state: result.data.stateOfOrigin,
          };

          // Validate NIN if it's returned and valid
          if (updatedData.nin && updatedData.nin.length === 11) {
            this.validateNin(updatedData);
          }

          delete updatedData.stateOfOrigin;
          delete updatedData.residentialAddress;
          delete updatedData.lgaOfOrigin;

          this.$set(list, index, updatedData);
        }
      } catch (error) {
        this.$toast.error(error.response.data.message);
      } finally {
        this.loading = false;
      }
    },

    handleBvnInput(value, agent, validation) {
      const { isValid, errorMessage, sanitizedValue } = validateBvnInput(value);

      agent.bvn = sanitizedValue;

      if (!isValid || sanitizedValue.length !== 11) {
        validation.bvn = errorMessage;
      } else {
        delete validation.bvn;
      }
    },

    handleInput(agent, field) {
      if (field.key === "nin") {
        field.value = field.value.replace(/\D/g, "").slice(0, 11);
      }

      if (field.key === "nin" && agent.nin.length === 11) {
        this.validateNin(agent);
      }
    },

    async validateNin(field) {
      console.log("validateNin");
      try {
        this.isValidatingNin = true;
        console.log(field.nin);

        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/onboarding/validate-nin`,
          { nin: field.nin },
        );

        if (response.status === "success") {
          this.ninStatus = "success";
          this.$toast.success(response.data.message);
        }
      } catch (error) {
        this.ninStatus = "error";
        this.$toast.error(error.response.data.message);
      } finally {
        this.isValidatingNin = false;
      }
    },

    handleSelectChange(field) {
      if (field.key === "stateOfOrigin" || field.key === "businessState")
        this.fetchLgas(field.value);
    },

    getOptions(fieldKey) {
      const optionsMap = {
        gender: gender,
        stateOfOrigin: this.utils.allStates,
        businessState: this.utils.allStates,
        lgaOfOrigin: (this.utils.lgas || []).map((lga) => ({
          key: lga.name,
          label: lga.name,
        })),
        businessLGA: (this.utils.lgas || []).map((lga) => ({
          key: lga.name,
          label: lga.name,
        })),
        socialMediaPlatform: socialMedia,
        merchantId: (this.utils.merchants || []).map((merchant) => ({
          key: merchant._id,
          label: merchant.merchantName,
        })),
        occupation: occupation,
        annualIncome: annualIncome,
        otherOccupation: occupation,
        otherIndustry: businessIndustries,
        otherAnnualIncome: annualIncome,
        others: otherOccupation,
      };
    },

    isEmptyPayload(list) {
      return !this[list] || this[list].length === 0;
    },

    async addEntity(title, list, endpointKey) {
      if (this.isEmptyPayload(list)) return;

      this.loading = true;

      try {
        const payload = {
          [title]: [...this[list]],
        };

        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/kyc/${endpointKey}/${this.agentId}`,
          payload,
        );

        if (response.data.status === "success") this.currentStepIndex++;
      } catch (error) {
        this.$toast.error(error.response.data.message);
      } finally {
        this.loading = false;
      }
    },

    async addDirectors() {
      await this.addEntity("directors", "directorsList", "addDirectors");
      this.currentPage = 3;
    },

    async addShareholders() {
      await this.addEntity(
        "shareholders",
        "shareholdersList",
        "addShareholders",
      );
      this.currentPage = 1;
    },
  },

  watch: {
    selectedPartnershipType(newValue) {
      if (!["Yes", "No"].includes(newValue)) {
        this.selectedPartnership = null;
        return;
      }
      this.selectedPartnership = newValue === "Yes";
    },

    "agent.nin"(newVal) {
      if (newVal && newVal.length === 11) {
        this.validateNin(this.agent);
      }
    },
  },
};
</script>

<style>
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.custom-modal-container {
  background-color: white;
  width: 100%;
  border-radius: 8px;
  max-width: 1000px;
  overflow: hidden;
  overflow-y: auto;
  max-height: 100vh;
  padding: 20px;
}

.custom-modal-container label {
  font-size: 15px;
  margin-bottom: 5px;
}

.spin {
  border: 2px solid rgba(101, 179, 199, 0.2) !important;
  border-left-color: #65b3c7 !important;
  display: block;
  width: 20px !important;
  height: 20px !important;
}
</style>
